import { CellFormatOptions, Icon } from '@octano/global-ui';
import { useEffect, useRef, useState, useMemo } from 'react';
import { PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import { DiscountTexts } from '../../../api/requests/studyPlansOffer';
import { AdmissionManagementFindItem } from '../../types';

const DiscountField = ({
  options,
}: {
  options: CellFormatOptions<AdmissionManagementFindItem>;
}) => {
  const spanRef = useRef<HTMLSpanElement | null>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const discounts = useMemo(
    () => options?.row?.posutlationDetailDisounts ?? [],
    [options?.row?.posutlationDetailDisounts],
  );

  useEffect(() => {
    if (spanRef.current) {
      setPopoverOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spanRef.current]);

  if (!discounts || discounts.length === 0) {
    return <></>; // O manejar el caso en que no hay descuentos
  }

  const uniqueId = `key_${options.row.postulationDetailId}`;

  return (
    <>
      <span ref={spanRef} id={uniqueId}>
        <Icon name="eye" size={16} />
      </span>
      {popoverOpen && (
        <UncontrolledPopover placement="left" target={uniqueId}>
          <PopoverHeader>Descuentos asignados</PopoverHeader>
          <PopoverBody style={{ maxHeight: '300px', overflow: 'auto' }}>
            <ul>
              {discounts.map((discount) => (
                <li key={discount.id}>
                  {DiscountTexts[discount.type]} - {discount.discountName} -{' '}
                  {discount.discountValue}% - {discount.discountCode}
                </li>
              ))}
            </ul>
          </PopoverBody>
        </UncontrolledPopover>
      )}
    </>
  );
};

export default DiscountField;
